export var Environments;
(function (Environments) {
    Environments["LOCAL"] = "LOCAL";
    Environments["DEV"] = "DEV";
    Environments["QA"] = "QA";
    Environments["STAGE"] = "STAGE";
    Environments["PROD"] = "PROD";
})(Environments || (Environments = {}));
